import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4add7f60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "transaction card shadow-sm" }
const _hoisted_2 = { class: "card-body accordion" }
const _hoisted_3 = { class: "d-flex flex-row align-items-center justify-content-between" }
const _hoisted_4 = ["data-bs-target", "aria-controls"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "text-start" }
const _hoisted_7 = { class: "card-title fw-semibold fs-5" }
const _hoisted_8 = { class: "d-flex flex-wrap gap-1 align-items-center" }
const _hoisted_9 = { class: "card-subtitle text-black-50 fs-6" }
const _hoisted_10 = { class: "d-flex flex-row align-items-center" }
const _hoisted_11 = ["id"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "bi bi-geo-alt fs-2" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["data-bs-target", "aria-controls"]
const _hoisted_15 = ["id"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-start fw-semibold fs-5 mt-2 mb-3" }, "Donation Details", -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 col-md-6 mt-1 align-items-start" }
const _hoisted_19 = { class: "text-start" }
const _hoisted_20 = { class: "fw-semibold" }
const _hoisted_21 = { class: "col-12 col-md-6 mt-1 align-items-start" }
const _hoisted_22 = { class: "text-start m-0" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "fw-semibold" }, "Request Time:", -1))
const _hoisted_24 = { class: "col-12 col-md-6 mt-1 align-items-start" }
const _hoisted_25 = { class: "text-start" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "fw-semibold" }, "Delivery Mode:", -1))
const _hoisted_27 = { class: "col-12 col-md-6 mt-1 align-items-start" }
const _hoisted_28 = { class: "text-start" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "fw-semibold" }, "Status:", -1))
const _hoisted_30 = { class: "col-md-12 mt-1" }
const _hoisted_31 = { class: "text-start" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "fw-semibold" }, "Delivery Notes:", -1))
const _hoisted_33 = { class: "col-md-12 mt-1" }
const _hoisted_34 = { class: "text-start" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "fw-semibold" }, "Optional Notes:", -1))
const _hoisted_36 = {
  key: 0,
  class: "d-flex flex-row align-items-center justify-content-end my-3"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary fw-medium rounded-0 py-2 px-3"
}, " Receive ", -1))
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Donations = _resolveComponent("Donations")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn flex-fill d-flex flew-row align-items-center",
          role: "button",
          "data-bs-toggle": "collapse",
          "data-bs-target": '#' + _ctx.transaction.transactionId,
          "aria-expanded": "false",
          "aria-controls": _ctx.transaction.transactionId
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: _ctx.setURL(_ctx.avatar),
              alt: 
                _ctx.role === 'Charity'
                  ? _ctx.transaction.donorName
                  : _ctx.transaction.charityName
              ,
              class: "avatar d-none d-sm-block rounded-circle object-fit-cover text-white bg-dark me-3"
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.role === "Charity"
                  ? _ctx.truncateText(_ctx.transaction.donorName)
                  : _ctx.truncateText(_ctx.transaction.charityName)), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.getDate(_ctx.transaction.createdAt)) + " • " + _toDisplayString(_ctx.transaction.distance / 1000) + "km away ", 1)
            ])
          ])
        ], 8, _hoisted_4),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "btn location-pin px-1",
            id: _ctx.transaction.transactionId + '-map-btn'
          }, _hoisted_13, 8, _hoisted_11),
          _createElementVNode("button", {
            type: "button",
            class: "accordion-button collapsed",
            role: "button",
            "data-bs-toggle": "collapse",
            "data-bs-target": '#' + _ctx.transaction.transactionId,
            "aria-expanded": "false",
            "aria-controls": _ctx.transaction.transactionId
          }, null, 8, _hoisted_14)
        ])
      ]),
      _createElementVNode("div", {
        class: "accordion-collapse collapse accordion-body border-top border-black-50 border-2 mt-3 pb-0",
        id: _ctx.transaction.transactionId
      }, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", _hoisted_19, [
              _createElementVNode("b", _hoisted_20, _toDisplayString(_ctx.role === "Charity" ? "Donor" : _ctx.role) + " Name:", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.role === "Charity"
                  ? _ctx.transaction.donorName
                  : _ctx.transaction.charityName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("p", _hoisted_22, [
              _hoisted_23,
              _createTextVNode(" " + _toDisplayString(_ctx.getTime(_ctx.transaction.createdAt)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("p", _hoisted_25, [
              _hoisted_26,
              _createTextVNode(" " + _toDisplayString(_ctx.transaction.deliveryMode), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", _hoisted_28, [
              _hoisted_29,
              _createTextVNode(" " + _toDisplayString(_ctx.transaction.status), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("p", _hoisted_31, [
              _hoisted_32,
              _createTextVNode(" " + _toDisplayString(_ctx.transaction.deliveryNotes), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("p", _hoisted_34, [
              _hoisted_35,
              _createTextVNode(" " + _toDisplayString(_ctx.transaction.optionalNotes), 1)
            ])
          ])
        ]),
        _createVNode(_component_Donations, {
          headers: _ctx.headers,
          donations: _ctx.transaction.donations
        }, null, 8, ["headers", "donations"]),
        (
            _ctx.role === 'Charity' &&
            _ctx.transaction.status !== 'Completed' &&
            _ctx.transaction.status !== 'Cancelled'
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
          : _createCommentVNode("", true)
      ], 8, _hoisted_15)
    ])
  ]))
}